import React, { useEffect } from 'react';
import './CustomCursor.css';

const CustomCursor = () => {
  useEffect(() => {
    const cursor = document.querySelector('.custom-cursor');

    const addHoverEffect = () => cursor.classList.add('hovered');
    const removeHoverEffect = () => cursor.classList.remove('hovered');

    // Attach hover listeners to specific elements
    const hoverElements = document.querySelectorAll('button, a'); // Target buttons and links
    hoverElements.forEach((element) => {
      element.addEventListener('mouseenter', addHoverEffect);
      element.addEventListener('mouseleave', removeHoverEffect);
    });

    // Move the cursor
    const moveCursor = (event) => {
      cursor.style.left = `${event.clientX}px`;
      cursor.style.top = `${event.clientY}px`;
    };
    document.addEventListener('mousemove', moveCursor);

    return () => {
      // Clean up event listeners
      hoverElements.forEach((element) => {
        element.removeEventListener('mouseenter', addHoverEffect);
        element.removeEventListener('mouseleave', removeHoverEffect);
      });
      document.removeEventListener('mousemove', moveCursor);
    };
  }, []);

  return <div className="custom-cursor"></div>;
};

export default CustomCursor;
